import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import "./auth.css";

const API_BASE = "https://xiadot.com/vendor_api";

export default function VendorRegister() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [showPass, setShowPass] = useState(false);

  const [form, setForm] = useState({
    shop_name: "",
    owner_name: "",
    email: "",
    phone: "",
    gst: "",
    password: "",
  });


  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((p) => ({ ...p, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.shop_name || !form.owner_name || !form.email || !form.phone || !form.password) {
      alert("Shop Name, Owner Name, Email, Phone, Password fill pannanum. GST optional.");
      return;
    }
    try {
      setLoading(true);
      const fd = new FormData();
      Object.entries(form).forEach(([k, v]) => fd.append(k, v || ""));
      const res = await fetch(`${API_BASE}/register.php`, { method: "POST", body: fd });
      const text = await res.text();
      let data = {};
      try { data = JSON.parse(text); } catch { }

      // Debug logging to understand the response
      console.log("Registration Response Status:", res.status);
      console.log("Registration Response Data:", data);
      console.log("Registration Response Text:", text);

      // Check if registration was successful - comprehensive check with fallback
      const isSuccess = data.success === true ||
        data.message?.includes("success") ||
        data.message?.includes("registered") ||
        data.message?.includes("completed") ||
        res.status === 200 ||
        res.status === 201;

      // Fallback: if we got any response (not a server error), assume success since data is being saved
      const isServerSuccess = res.status !== 500 && res.status !== 0 && text.length > 0;
      console.log("Is Success:", isSuccess, "Is Server Success:", isServerSuccess);
      const msg = data?.message || "Unknown server response";
      if (msg.includes("Email already exists")) {
        alert("Email already registered. Please use a different email or try logging in.");
      } else if (msg.includes("Phone number already exists")) {
        alert("Phone number already registered. Please use a different number.");
      } else if (data?.success) {
        alert(msg || "Registered successfully! Please login.");
        navigate("/login");
      } else {
        alert(`Registration conflict. Please check your details: ${msg}`);
      }
    } catch (err) {
      alert("Server error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="vl-page">

      {/* ── LEFT branding panel — exact same as Login ── */}
      <div className="vl-left">
        <div className="vl-left-glow-1" />
        <div className="vl-left-glow-2" />

        <div className="vl-left-top">
          <div className="vl-logo">
            <div className="vl-logo-icon">
              <img src={process.env.PUBLIC_URL + "/logo.png"} alt="Yuro Shopy" />
            </div>
            <span className="vl-logo-name">YURO SHOPY</span>
          </div>
        </div>

        <div className="vl-left-mid">
          <div className="vl-left-tag">Vendor Portal</div>
          <h1 className="vl-left-h1">Your store,<br /><em>fully in control</em></h1>
          <p className="vl-left-p">Manage products, track orders, handle payouts and grow your business — all from one powerful dashboard.</p>

          <div className="vl-stat-row">
            <div className="vl-stat">
              <span className="vl-stat-num">12K+</span>
              <span className="vl-stat-lbl">Active Vendors</span>
            </div>
            <div className="vl-stat-div" />
            <div className="vl-stat">
              <span className="vl-stat-num">98%</span>
              <span className="vl-stat-lbl">Uptime SLA</span>
            </div>
            <div className="vl-stat-div" />
            <div className="vl-stat">
              <span className="vl-stat-num">4.9★</span>
              <span className="vl-stat-lbl">Satisfaction</span>
            </div>
          </div>
        </div>

        <div className="vl-left-bot">
          {["Real-time sales analytics", "Inventory & order management", "Instant payout tracking"].map((f, i) => (
            <div className="vl-feat" key={i}>
              <div className="vl-feat-check">
                <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
              </div>
              {f}
            </div>
          ))}
        </div>
      </div>

      {/* ── RIGHT: Form panel — exact same as Login ── */}
      <div className="vl-right">

        {/* Mobile-only top branding */}
        <div className="vl-mob-brand">
          <div className="vl-logo-icon" style={{ width: 34, height: 34, borderRadius: 9 }}>
            <img src={process.env.PUBLIC_URL + "/logo.png"} alt="Yuro Shopy" />
          </div>
          <span className="vl-logo-name">YURO SHOPY</span>
        </div>

        {/* Mobile-only hero */}
        <div className="vl-mob-hero">
          <div className="vl-left-tag" style={{ marginBottom: 12 }}>Vendor Portal</div>
          <h2 className="vl-mob-h2">Your store, fully in control</h2>
          <p className="vl-mob-p">Manage products, track orders and grow your business.</p>
          <div className="vl-mob-stats">
            <div className="vl-mob-stat"><strong>12K+</strong><span>Vendors</span></div>
            <div className="vl-mob-stat"><strong>98%</strong><span>Uptime</span></div>
            <div className="vl-mob-stat"><strong>4.9★</strong><span>Rating</span></div>
          </div>
        </div>

        {/* Form card */}
        <div className="vl-card">
          <div className="vl-card-label">Get Started</div>
          <h2 className="vl-card-title">Create your account</h2>
          <p className="vl-card-sub">Fill in your details to get started</p>

          <form onSubmit={handleSubmit}>

            {/* Row 1 */}
            <div className="vl-reg-grid">
              <div className="vl-field">
                <label className="vl-lbl">Shop Name</label>
                <div className="vl-iw">
                  <span className="vl-ii">
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                      <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" /><polyline points="9 22 9 12 15 12 15 22" />
                    </svg>
                  </span>
                  <input className="vl-inp" name="shop_name" value={form.shop_name} onChange={handleChange} placeholder="Enter shop name" required />
                </div>
              </div>

              <div className="vl-field">
                <label className="vl-lbl">Owner Name</label>
                <div className="vl-iw">
                  <span className="vl-ii">
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                      <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" /><circle cx="12" cy="7" r="4" />
                    </svg>
                  </span>
                  <input className="vl-inp" name="owner_name" value={form.owner_name} onChange={handleChange} placeholder="Enter owner name" required />
                </div>
              </div>
            </div>

            {/* Row 2 */}
            <div className="vl-reg-grid">
              <div className="vl-field">
                <label className="vl-lbl">Email</label>
                <div className="vl-iw">
                  <span className="vl-ii">
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                      <rect x="2" y="4" width="20" height="16" rx="3" /><path d="M2 7l10 7 10-7" />
                    </svg>
                  </span>
                  <input className="vl-inp" type="email" name="email" value={form.email} onChange={handleChange} placeholder="Enter email" required />
                </div>
              </div>

              <div className="vl-field">
                <label className="vl-lbl">Phone</label>
                <div className="vl-iw">
                  <span className="vl-ii">
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                      <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81a19.79 19.79 0 01-3.07-8.63A2 2 0 012 1h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 8.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" />
                    </svg>
                  </span>
                  <input className="vl-inp" name="phone" value={form.phone} onChange={handleChange} placeholder="Enter phone" inputMode="numeric" required />
                </div>
              </div>
            </div>

            {/* Row 3 */}
            <div className="vl-reg-grid">
              <div className="vl-field">
                <label className="vl-lbl">GST <span style={{ fontSize: 11, color: "#94a3b8", fontWeight: 500 }}>(optional)</span></label>
                <div className="vl-iw">
                  <span className="vl-ii">
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                      <rect x="2" y="3" width="20" height="14" rx="2" /><line x1="8" y1="21" x2="16" y2="21" /><line x1="12" y1="17" x2="12" y2="21" />
                    </svg>
                  </span>
                  <input className="vl-inp" name="gst" value={form.gst} onChange={handleChange} placeholder="Enter GST number" />
                </div>
              </div>

              <div className="vl-field">
                <label className="vl-lbl">Password</label>
                <div className="vl-iw">
                  <span className="vl-ii">
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                      <rect x="3" y="11" width="18" height="11" rx="2" /><path d="M7 11V7a5 5 0 0110 0v4" />
                    </svg>
                  </span>
                  <input
                    className="vl-inp vl-inp-p"
                    type={showPass ? "text" : "password"}
                    name="password"
                    value={form.password}
                    onChange={handleChange}
                    placeholder="Create password"
                    required
                  />
                  <button type="button" className="vl-eye" onClick={() => setShowPass(s => !s)}>
                    {showPass ? (
                      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                        <path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94" />
                        <path d="M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19" />
                        <line x1="1" y1="1" x2="23" y2="23" />
                      </svg>
                    ) : (
                      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" /><circle cx="12" cy="12" r="3" />
                      </svg>
                    )}
                  </button>
                </div>
              </div>
            </div>

            <button className="vl-btn" type="submit" disabled={loading}>
              {loading ? (
                <><span className="vl-spin" />Registering…</>
              ) : (
                <>Create Account
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                    <line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" />
                  </svg>
                </>
              )}
            </button>
          </form>

          <div className="vl-footer">
            Already have an account? <Link to="/login">Sign in</Link>
          </div>
        </div>

        {/* Mobile feature pills */}
        <div className="vl-mob-feats">
          {["Sales analytics", "Order management", "Payout tracking"].map((f, i) => (
            <div className="vl-mob-pill" key={i}>
              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round">
                <polyline points="20 6 9 17 4 12" />
              </svg>
              {f}
            </div>
          ))}
        </div>

      </div>
    </div>
  );
}